import { createAction } from '@reduxjs/toolkit';
import { AlertState } from './alertTypes';

export const showAlertAction = createAction<AlertState>('SNACK/SHOW');
export const hideAlertAction = createAction<void>('SNACK/HIDE');
